export default __webpack_public_path__ + "static/media/icon-card-aircraft.59d598cf.svg";